export default __webpack_public_path__ + "static/reading-es@2x-ad14e0879fd349e9c186d5d6069ee55d.png";